import { render } from "./DocumentEditor.vue?vue&type=template&id=5fa877f4&scoped=true&ts=true"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts"

import "./DocumentEditor.vue?vue&type=style&index=0&id=5fa877f4&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa877f4"]])

export default __exports__